import AdditionalListingsView from './additional-listings-view';

const AdditionalListingsPage = {
    name: 'AdditionalListings',
    list: AdditionalListingsView
};

export default AdditionalListingsPage;
